<template>
  <hic-list-page title="护理">

  </hic-list-page>
</template>
<script>
export default {
  data() {
    return {

    }
  },
}
</script>